import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { LightBox } from '@lion-design/core';
import { TravelTypes } from '@Redux/detail/Group/interfaces';
import { RootState } from '@Redux/detail/store';
import DetailList from './subComponents/DetailList';
import PriceList from './subComponents/PriceList';
import TaxList from './subComponents/TaxList';
import styles from './styles.module.scss';

interface I_Props {
    open: boolean;
    ToggleLightBox: (open: boolean) => void;
    storyData?: I_StoryData;
}

export interface I_StoryData {
    isB2E: boolean;
    TravelType: TravelTypes;
}

function GroupDetailPrice({ open, ToggleLightBox }: I_Props) {
    const group = useSelector((state: RootState) => state.groupReducer);
    const PricesInfo = useSelector((state: RootState) => state.groupReducer.PricesInfo);
    // 防止幣別為 null 或不存在
    const currency = group.GroupInfo.CurrencyCode
        ? `（以 ${group.GroupInfo.CurrencyCode} 計價）`
        : '';

    return PricesInfo ? (
        <LightBox
            title={`費用說明${currency}`}
            className={cN(styles.container, 'group_detail_price')}
            open={open}
            ToggleLightBox={ToggleLightBox}
        >
            <DetailList />
            <PriceList />
            <TaxList />
        </LightBox>
    ) : null;
}

export default GroupDetailPrice;
